import { render } from "./PaiementSuccess.vue?vue&type=template&id=70e40e8d&scoped=true&ts=true"
import script from "./PaiementSuccess.vue?vue&type=script&lang=ts"
export * from "./PaiementSuccess.vue?vue&type=script&lang=ts"

import "./PaiementSuccess.vue?vue&type=style&index=0&id=70e40e8d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70e40e8d"]])

export default __exports__